<ng-container *ngIf="assistanceBundle$ | async as assistanceBundle">
  <ion-header>
    <ion-toolbar>
      <ion-grid>
        <ion-row>
          <ion-col sizeLg="8" size="12">
            <ion-title id="title">
              <ion-icon
                *ngIf="assistanceBundle.selectedAssistance?.isBilled"
                name="lock-closed"
                color="danger"
                id="lock"
              ></ion-icon>

              <div class="title-wrapper">
                <span
                  *ngIf="assistanceBundle.selectedAssistance"
                  id="title-text"
                  (click)="goToClient(assistanceBundle.selectedAssistance.clientId)"
                >
                  Asistence
                  <ng-container *ngIf="assistanceBundle.selectedAssistance.clientName">
                    : {{ assistanceBundle.selectedAssistance.clientName }}
                  </ng-container>
                </span>
                <span class="title-superadmin" *ngIf="userService.isCurrentUserSuperadmin() | async">
                  <span *ngIf="assistanceBundle.selectedAssistance?.id">
                    , ID: {{ assistanceBundle.selectedAssistance?.id }}
                  </span>
                  <span *ngIf="assistanceBundle.selectedAssistance?.recurrenceParentId">
                    , recurrenceParentID: {{ assistanceBundle.selectedAssistance?.recurrenceParentId }}
                  </span>
                  <span *ngIf="assistanceBundle.selectedAssistance?.bundleParentId">
                    , bundleParentId: {{ assistanceBundle.selectedAssistance?.bundleParentId }}
                  </span>
                  <span *ngIf="assistanceBundle.selectedAssistance?.allocationId">
                    , allocationId: {{ assistanceBundle.selectedAssistance?.allocationId }}
                  </span>
                </span>
              </div>
            </ion-title>
          </ion-col>

          <ion-col sizeLg="4" size="12" class="modeSubtitle" data-cy="recurrenceMode">
            Režim úprav:
            {{ editor?.humanizedRecurrenceEditingMode }}
          </ion-col>
        </ion-row>
      </ion-grid>

      <ion-buttons slot="end">
        <ion-button (click)="tryClose()" data-cy="closeBtn">
          <ion-icon name="close"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <ion-content>
    <ion-card>
      <ion-card-header *ngIf="bundleChildAssistancesEnabled && assistanceBundle.main">
        <ion-segment
          #segmentButton
          [ngModel]="selectedBundleSegment"
          (ionChange)="segmentChanged($event, assistanceBundle)"
          [disabled]="!isBundleNavigEnabled()"
        >
          <ng-container *ngIf="assistanceBundle">
            <ion-segment-button
              *ngFor="let a of assistanceBundle.all; let i = index"
              [value]="i.toString()"
              class="bundle-navig-assistance-{{ i }}"
            >
              <ion-label>
                <span class="circular" *ngIf="!!i">+{{ i }}</span>
                {{ a.plannedFrom | date: 'HH:mm' }}-{{ a.plannedTo | date: 'HH:mm' }}
              </ion-label>
            </ion-segment-button>
          </ng-container>

          <ion-segment-button
            (click)="bundleChildAssistanceAddBtnClicked(assistanceBundle, $event)"
            [value]="BUNDLE_SEGMENT_ADD"
            [disabled]="
              isCreateMode(assistanceBundle) ||
              assistanceBundle.main.isExpanded() ||
              assistanceBundle.main.isRecurrentButNotException() ||
              (assistanceEditorModalService.editorPreventAddBundleChild$ | async)
            "
            class="bundle-navig-assistance-add"
          >
            <ion-icon name="add"></ion-icon>
          </ion-segment-button>
        </ion-segment>
      </ion-card-header>

      <ion-card-content *ngIf="assistanceBundle">
        <div id="bundledAssistancesWrapper">
          <app-assistance-editor
            #editor
            [assistance]="assistanceBundle.selectedAssistance"
            [recurrenceEditingMode]="recurrenceEditingMode"
            [isInBundle]="!!assistanceBundle.children.length"
            [editableHandler]="editableStateHandler"
            (bundleChildAssistanceDeleted)="bundleChildAssistanceDeleted(assistanceBundle, $event)"
            (recurrenceEditingModeChange)="recurrenceEditingModeChanged($event)"
            (notifyURIDChange)="onURIDChange($event)"
          ></app-assistance-editor>
        </div>
      </ion-card-content>
    </ion-card>
  </ion-content>
</ng-container>
